const openedPaymentPage = {
  fawry: {
    title: 'تم إنشاء عملية الدفع الخاصة بك!',
    importantMessage: {
      title: 'من المهم أن تعرف',
      description: 'يمكنك الدفع باستخدام الرقم المرجعي من خلال أي من قنوات أو منافذ فوري أو من خلال Fawry App  و لتجنب إلغاء الطلب برجاء إكمال عملية الدفع خلال الوقت المحدد',
    },
    orderDetail: {
      expirationDate: 'تاريخ انتهاء مدة الدفع:',
      totalAmount: 'المبلغ الإجمالي',
    },
    referenceNumber: {
      title: 'الرقم المرجعي',
      copy: 'نسخ',
      copied: 'تم نسخها',
    },
  },
  customer: {
    form: {
      fieldCustomerBirthdate: {
        label: 'تاريخ الميلاد',
        validationMessage: {
          empty: 'يرجى تقديم تاريخ ميلادك',
          invalid: 'تاريخ ميلاد غير صالح',
          serverError: 'خطأ في الخادم. يرجى المحاولة مرة أخرى لاحقًا.',
        },
      },
    },
  },
  cryptocurrency: {
    disclaimer1: 'تتم معالجة المدفوعات بالعملات المشفرة حصريًا من قبل مزودي خدمات خارجيين ومُرخصين، وليس من قبل EBANX. يتم تحديد تفاصيل المزودين، بما في ذلك تراخيصهم وحالتهم التنظيمية، في الوثيقة/المكان الساري (المعمول به)',
    termsAndConditions: 'الشروط والأحكام',
    disclaimer2:  '',
    merchantInfo: {
      returnButton: 'يمكنك إلغاء هذه الدفع والعودة إلى صفحة الدفع لاختيار طريقة دفع أخرى.',
      backTo: 'إلغاء والعودة',
    },
  },
};

module.exports = openedPaymentPage;
